import {
  Lager_Treyd_Auth_Onfidoapplicant,
  Lager_Treyd_Auth_Onfidocheck,
} from '@/__generated__/graphql';
import { OnfidoReport } from '@/types/onfido';
import { TypedDocumentNode, gql } from '@apollo/client';

type OnfidoApplicant = Pick<Lager_Treyd_Auth_Onfidoapplicant, 'user_id'>;

export type OnfidoCheck = Pick<
  Lager_Treyd_Auth_Onfidocheck,
  'applicant_id' | 'check_id' | 'result' | 'status' | 'onfidoapplicant'
> & {
  onfidoapplicant: OnfidoApplicant;
  status: 'in_progress' | 'complete';
  result: 'clear' | 'consider';
  reports_payload: {
    reports: OnfidoReport[];
  };
};

export type GetOnFidoChecksQueryType = {
  lager_treyd_auth_onfidocheck: OnfidoCheck[];
};

export type GetOnFidoChecksQueryVariables = {
  userId: number;
};

export const getOnFidoCheckQuery = gql`
  query getOnFidoCheckQuery($userId: Int!) {
    lager_treyd_auth_onfidocheck(
      where: { onfidoapplicant: { user_id: { _eq: $userId } } }
      order_by: { created: desc_nulls_last }
    ) {
      onfidoapplicant {
        user_id
      }
      applicant_id
      check_id
      result
      status
      reports_payload
    }
  }
` as TypedDocumentNode<GetOnFidoChecksQueryType, GetOnFidoChecksQueryVariables>;
